/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as GetInTouchImport } from './routes/get-in-touch'
import { Route as ConnectImport } from './routes/connect'
import { Route as VenuereviewsVenueIdImport } from './routes/venuereviews.$venueId'
import { Route as VenuephotosVenueSlugImport } from './routes/venuephotos.$venueSlug'
import { Route as VenuedetailsVenueIdImport } from './routes/venuedetails.$venueId'
import { Route as LoginEmailImport } from './routes/login.$email'
import { Route as ContentSlugImport } from './routes/content.$slug'
import { Route as VerifyuserCodeUserEmailImport } from './routes/verifyuser.$code.user.$email'
import { Route as SavedplacedetailsSavedPlaceIdUserUserIdImport } from './routes/savedplacedetails.$savedPlaceId.user.$userId'
import { Route as PasswordresetCodeUserEmailImport } from './routes/passwordreset.$code.user.$email'

// Create Virtual Routes

const YourProfileLazyImport = createFileRoute('/your-profile')()
const YourActivityLazyImport = createFileRoute('/your-activity')()
const YourAccessibilityProfileLazyImport = createFileRoute(
  '/your-accessibility-profile',
)()
const MysavedplacesLazyImport = createFileRoute('/mysavedplaces')()
const IndexLazyImport = createFileRoute('/')()

// Create/Update Routes

const YourProfileLazyRoute = YourProfileLazyImport.update({
  id: '/your-profile',
  path: '/your-profile',
  getParentRoute: () => rootRoute,
} as any).lazy(() => import('./routes/your-profile.lazy').then((d) => d.Route))

const YourActivityLazyRoute = YourActivityLazyImport.update({
  id: '/your-activity',
  path: '/your-activity',
  getParentRoute: () => rootRoute,
} as any).lazy(() => import('./routes/your-activity.lazy').then((d) => d.Route))

const YourAccessibilityProfileLazyRoute =
  YourAccessibilityProfileLazyImport.update({
    id: '/your-accessibility-profile',
    path: '/your-accessibility-profile',
    getParentRoute: () => rootRoute,
  } as any).lazy(() =>
    import('./routes/your-accessibility-profile.lazy').then((d) => d.Route),
  )

const MysavedplacesLazyRoute = MysavedplacesLazyImport.update({
  id: '/mysavedplaces',
  path: '/mysavedplaces',
  getParentRoute: () => rootRoute,
} as any).lazy(() => import('./routes/mysavedplaces.lazy').then((d) => d.Route))

const GetInTouchRoute = GetInTouchImport.update({
  id: '/get-in-touch',
  path: '/get-in-touch',
  getParentRoute: () => rootRoute,
} as any)

const ConnectRoute = ConnectImport.update({
  id: '/connect',
  path: '/connect',
  getParentRoute: () => rootRoute,
} as any)

const IndexLazyRoute = IndexLazyImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRoute,
} as any).lazy(() => import('./routes/index.lazy').then((d) => d.Route))

const VenuereviewsVenueIdRoute = VenuereviewsVenueIdImport.update({
  id: '/venuereviews/$venueId',
  path: '/venuereviews/$venueId',
  getParentRoute: () => rootRoute,
} as any)

const VenuephotosVenueSlugRoute = VenuephotosVenueSlugImport.update({
  id: '/venuephotos/$venueSlug',
  path: '/venuephotos/$venueSlug',
  getParentRoute: () => rootRoute,
} as any)

const VenuedetailsVenueIdRoute = VenuedetailsVenueIdImport.update({
  id: '/venuedetails/$venueId',
  path: '/venuedetails/$venueId',
  getParentRoute: () => rootRoute,
} as any)

const LoginEmailRoute = LoginEmailImport.update({
  id: '/login/$email',
  path: '/login/$email',
  getParentRoute: () => rootRoute,
} as any)

const ContentSlugRoute = ContentSlugImport.update({
  id: '/content/$slug',
  path: '/content/$slug',
  getParentRoute: () => rootRoute,
} as any)

const VerifyuserCodeUserEmailRoute = VerifyuserCodeUserEmailImport.update({
  id: '/verifyuser/$code/user/$email',
  path: '/verifyuser/$code/user/$email',
  getParentRoute: () => rootRoute,
} as any)

const SavedplacedetailsSavedPlaceIdUserUserIdRoute =
  SavedplacedetailsSavedPlaceIdUserUserIdImport.update({
    id: '/savedplacedetails/$savedPlaceId/user/$userId',
    path: '/savedplacedetails/$savedPlaceId/user/$userId',
    getParentRoute: () => rootRoute,
  } as any)

const PasswordresetCodeUserEmailRoute = PasswordresetCodeUserEmailImport.update(
  {
    id: '/passwordreset/$code/user/$email',
    path: '/passwordreset/$code/user/$email',
    getParentRoute: () => rootRoute,
  } as any,
)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexLazyImport
      parentRoute: typeof rootRoute
    }
    '/connect': {
      id: '/connect'
      path: '/connect'
      fullPath: '/connect'
      preLoaderRoute: typeof ConnectImport
      parentRoute: typeof rootRoute
    }
    '/get-in-touch': {
      id: '/get-in-touch'
      path: '/get-in-touch'
      fullPath: '/get-in-touch'
      preLoaderRoute: typeof GetInTouchImport
      parentRoute: typeof rootRoute
    }
    '/mysavedplaces': {
      id: '/mysavedplaces'
      path: '/mysavedplaces'
      fullPath: '/mysavedplaces'
      preLoaderRoute: typeof MysavedplacesLazyImport
      parentRoute: typeof rootRoute
    }
    '/your-accessibility-profile': {
      id: '/your-accessibility-profile'
      path: '/your-accessibility-profile'
      fullPath: '/your-accessibility-profile'
      preLoaderRoute: typeof YourAccessibilityProfileLazyImport
      parentRoute: typeof rootRoute
    }
    '/your-activity': {
      id: '/your-activity'
      path: '/your-activity'
      fullPath: '/your-activity'
      preLoaderRoute: typeof YourActivityLazyImport
      parentRoute: typeof rootRoute
    }
    '/your-profile': {
      id: '/your-profile'
      path: '/your-profile'
      fullPath: '/your-profile'
      preLoaderRoute: typeof YourProfileLazyImport
      parentRoute: typeof rootRoute
    }
    '/content/$slug': {
      id: '/content/$slug'
      path: '/content/$slug'
      fullPath: '/content/$slug'
      preLoaderRoute: typeof ContentSlugImport
      parentRoute: typeof rootRoute
    }
    '/login/$email': {
      id: '/login/$email'
      path: '/login/$email'
      fullPath: '/login/$email'
      preLoaderRoute: typeof LoginEmailImport
      parentRoute: typeof rootRoute
    }
    '/venuedetails/$venueId': {
      id: '/venuedetails/$venueId'
      path: '/venuedetails/$venueId'
      fullPath: '/venuedetails/$venueId'
      preLoaderRoute: typeof VenuedetailsVenueIdImport
      parentRoute: typeof rootRoute
    }
    '/venuephotos/$venueSlug': {
      id: '/venuephotos/$venueSlug'
      path: '/venuephotos/$venueSlug'
      fullPath: '/venuephotos/$venueSlug'
      preLoaderRoute: typeof VenuephotosVenueSlugImport
      parentRoute: typeof rootRoute
    }
    '/venuereviews/$venueId': {
      id: '/venuereviews/$venueId'
      path: '/venuereviews/$venueId'
      fullPath: '/venuereviews/$venueId'
      preLoaderRoute: typeof VenuereviewsVenueIdImport
      parentRoute: typeof rootRoute
    }
    '/passwordreset/$code/user/$email': {
      id: '/passwordreset/$code/user/$email'
      path: '/passwordreset/$code/user/$email'
      fullPath: '/passwordreset/$code/user/$email'
      preLoaderRoute: typeof PasswordresetCodeUserEmailImport
      parentRoute: typeof rootRoute
    }
    '/savedplacedetails/$savedPlaceId/user/$userId': {
      id: '/savedplacedetails/$savedPlaceId/user/$userId'
      path: '/savedplacedetails/$savedPlaceId/user/$userId'
      fullPath: '/savedplacedetails/$savedPlaceId/user/$userId'
      preLoaderRoute: typeof SavedplacedetailsSavedPlaceIdUserUserIdImport
      parentRoute: typeof rootRoute
    }
    '/verifyuser/$code/user/$email': {
      id: '/verifyuser/$code/user/$email'
      path: '/verifyuser/$code/user/$email'
      fullPath: '/verifyuser/$code/user/$email'
      preLoaderRoute: typeof VerifyuserCodeUserEmailImport
      parentRoute: typeof rootRoute
    }
  }
}

// Create and export the route tree

export interface FileRoutesByFullPath {
  '/': typeof IndexLazyRoute
  '/connect': typeof ConnectRoute
  '/get-in-touch': typeof GetInTouchRoute
  '/mysavedplaces': typeof MysavedplacesLazyRoute
  '/your-accessibility-profile': typeof YourAccessibilityProfileLazyRoute
  '/your-activity': typeof YourActivityLazyRoute
  '/your-profile': typeof YourProfileLazyRoute
  '/content/$slug': typeof ContentSlugRoute
  '/login/$email': typeof LoginEmailRoute
  '/venuedetails/$venueId': typeof VenuedetailsVenueIdRoute
  '/venuephotos/$venueSlug': typeof VenuephotosVenueSlugRoute
  '/venuereviews/$venueId': typeof VenuereviewsVenueIdRoute
  '/passwordreset/$code/user/$email': typeof PasswordresetCodeUserEmailRoute
  '/savedplacedetails/$savedPlaceId/user/$userId': typeof SavedplacedetailsSavedPlaceIdUserUserIdRoute
  '/verifyuser/$code/user/$email': typeof VerifyuserCodeUserEmailRoute
}

export interface FileRoutesByTo {
  '/': typeof IndexLazyRoute
  '/connect': typeof ConnectRoute
  '/get-in-touch': typeof GetInTouchRoute
  '/mysavedplaces': typeof MysavedplacesLazyRoute
  '/your-accessibility-profile': typeof YourAccessibilityProfileLazyRoute
  '/your-activity': typeof YourActivityLazyRoute
  '/your-profile': typeof YourProfileLazyRoute
  '/content/$slug': typeof ContentSlugRoute
  '/login/$email': typeof LoginEmailRoute
  '/venuedetails/$venueId': typeof VenuedetailsVenueIdRoute
  '/venuephotos/$venueSlug': typeof VenuephotosVenueSlugRoute
  '/venuereviews/$venueId': typeof VenuereviewsVenueIdRoute
  '/passwordreset/$code/user/$email': typeof PasswordresetCodeUserEmailRoute
  '/savedplacedetails/$savedPlaceId/user/$userId': typeof SavedplacedetailsSavedPlaceIdUserUserIdRoute
  '/verifyuser/$code/user/$email': typeof VerifyuserCodeUserEmailRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/': typeof IndexLazyRoute
  '/connect': typeof ConnectRoute
  '/get-in-touch': typeof GetInTouchRoute
  '/mysavedplaces': typeof MysavedplacesLazyRoute
  '/your-accessibility-profile': typeof YourAccessibilityProfileLazyRoute
  '/your-activity': typeof YourActivityLazyRoute
  '/your-profile': typeof YourProfileLazyRoute
  '/content/$slug': typeof ContentSlugRoute
  '/login/$email': typeof LoginEmailRoute
  '/venuedetails/$venueId': typeof VenuedetailsVenueIdRoute
  '/venuephotos/$venueSlug': typeof VenuephotosVenueSlugRoute
  '/venuereviews/$venueId': typeof VenuereviewsVenueIdRoute
  '/passwordreset/$code/user/$email': typeof PasswordresetCodeUserEmailRoute
  '/savedplacedetails/$savedPlaceId/user/$userId': typeof SavedplacedetailsSavedPlaceIdUserUserIdRoute
  '/verifyuser/$code/user/$email': typeof VerifyuserCodeUserEmailRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/connect'
    | '/get-in-touch'
    | '/mysavedplaces'
    | '/your-accessibility-profile'
    | '/your-activity'
    | '/your-profile'
    | '/content/$slug'
    | '/login/$email'
    | '/venuedetails/$venueId'
    | '/venuephotos/$venueSlug'
    | '/venuereviews/$venueId'
    | '/passwordreset/$code/user/$email'
    | '/savedplacedetails/$savedPlaceId/user/$userId'
    | '/verifyuser/$code/user/$email'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/connect'
    | '/get-in-touch'
    | '/mysavedplaces'
    | '/your-accessibility-profile'
    | '/your-activity'
    | '/your-profile'
    | '/content/$slug'
    | '/login/$email'
    | '/venuedetails/$venueId'
    | '/venuephotos/$venueSlug'
    | '/venuereviews/$venueId'
    | '/passwordreset/$code/user/$email'
    | '/savedplacedetails/$savedPlaceId/user/$userId'
    | '/verifyuser/$code/user/$email'
  id:
    | '__root__'
    | '/'
    | '/connect'
    | '/get-in-touch'
    | '/mysavedplaces'
    | '/your-accessibility-profile'
    | '/your-activity'
    | '/your-profile'
    | '/content/$slug'
    | '/login/$email'
    | '/venuedetails/$venueId'
    | '/venuephotos/$venueSlug'
    | '/venuereviews/$venueId'
    | '/passwordreset/$code/user/$email'
    | '/savedplacedetails/$savedPlaceId/user/$userId'
    | '/verifyuser/$code/user/$email'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  IndexLazyRoute: typeof IndexLazyRoute
  ConnectRoute: typeof ConnectRoute
  GetInTouchRoute: typeof GetInTouchRoute
  MysavedplacesLazyRoute: typeof MysavedplacesLazyRoute
  YourAccessibilityProfileLazyRoute: typeof YourAccessibilityProfileLazyRoute
  YourActivityLazyRoute: typeof YourActivityLazyRoute
  YourProfileLazyRoute: typeof YourProfileLazyRoute
  ContentSlugRoute: typeof ContentSlugRoute
  LoginEmailRoute: typeof LoginEmailRoute
  VenuedetailsVenueIdRoute: typeof VenuedetailsVenueIdRoute
  VenuephotosVenueSlugRoute: typeof VenuephotosVenueSlugRoute
  VenuereviewsVenueIdRoute: typeof VenuereviewsVenueIdRoute
  PasswordresetCodeUserEmailRoute: typeof PasswordresetCodeUserEmailRoute
  SavedplacedetailsSavedPlaceIdUserUserIdRoute: typeof SavedplacedetailsSavedPlaceIdUserUserIdRoute
  VerifyuserCodeUserEmailRoute: typeof VerifyuserCodeUserEmailRoute
}

const rootRouteChildren: RootRouteChildren = {
  IndexLazyRoute: IndexLazyRoute,
  ConnectRoute: ConnectRoute,
  GetInTouchRoute: GetInTouchRoute,
  MysavedplacesLazyRoute: MysavedplacesLazyRoute,
  YourAccessibilityProfileLazyRoute: YourAccessibilityProfileLazyRoute,
  YourActivityLazyRoute: YourActivityLazyRoute,
  YourProfileLazyRoute: YourProfileLazyRoute,
  ContentSlugRoute: ContentSlugRoute,
  LoginEmailRoute: LoginEmailRoute,
  VenuedetailsVenueIdRoute: VenuedetailsVenueIdRoute,
  VenuephotosVenueSlugRoute: VenuephotosVenueSlugRoute,
  VenuereviewsVenueIdRoute: VenuereviewsVenueIdRoute,
  PasswordresetCodeUserEmailRoute: PasswordresetCodeUserEmailRoute,
  SavedplacedetailsSavedPlaceIdUserUserIdRoute:
    SavedplacedetailsSavedPlaceIdUserUserIdRoute,
  VerifyuserCodeUserEmailRoute: VerifyuserCodeUserEmailRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/connect",
        "/get-in-touch",
        "/mysavedplaces",
        "/your-accessibility-profile",
        "/your-activity",
        "/your-profile",
        "/content/$slug",
        "/login/$email",
        "/venuedetails/$venueId",
        "/venuephotos/$venueSlug",
        "/venuereviews/$venueId",
        "/passwordreset/$code/user/$email",
        "/savedplacedetails/$savedPlaceId/user/$userId",
        "/verifyuser/$code/user/$email"
      ]
    },
    "/": {
      "filePath": "index.lazy.tsx"
    },
    "/connect": {
      "filePath": "connect.tsx"
    },
    "/get-in-touch": {
      "filePath": "get-in-touch.tsx"
    },
    "/mysavedplaces": {
      "filePath": "mysavedplaces.lazy.tsx"
    },
    "/your-accessibility-profile": {
      "filePath": "your-accessibility-profile.lazy.tsx"
    },
    "/your-activity": {
      "filePath": "your-activity.lazy.tsx"
    },
    "/your-profile": {
      "filePath": "your-profile.lazy.tsx"
    },
    "/content/$slug": {
      "filePath": "content.$slug.tsx"
    },
    "/login/$email": {
      "filePath": "login.$email.tsx"
    },
    "/venuedetails/$venueId": {
      "filePath": "venuedetails.$venueId.tsx"
    },
    "/venuephotos/$venueSlug": {
      "filePath": "venuephotos.$venueSlug.tsx"
    },
    "/venuereviews/$venueId": {
      "filePath": "venuereviews.$venueId.tsx"
    },
    "/passwordreset/$code/user/$email": {
      "filePath": "passwordreset.$code.user.$email.tsx"
    },
    "/savedplacedetails/$savedPlaceId/user/$userId": {
      "filePath": "savedplacedetails.$savedPlaceId.user.$userId.tsx"
    },
    "/verifyuser/$code/user/$email": {
      "filePath": "verifyuser.$code.user.$email.tsx"
    }
  }
}
ROUTE_MANIFEST_END */
